
import Vue from "vue";
import { APPLICATION } from "@/store/applications";
import { mapGetters } from "vuex";
import { IApplicationStatus } from "@/store/applications/types";
import { ROUTE_NAMES } from "@/routes";
import { IRootState } from "@/store/types";
import store from "@/store";

export default Vue.extend({
  computed: {
    activeTab: {
      get() {
        return store.state.application.activeApplicationTab;
      },
      set(value: any) {
        this.$store.commit(APPLICATION.NS(APPLICATION.MUTATIONS.SET_ACTIVE_APPLICATIONS_TAB), value);
      }
    }
  }
});
